var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedCross = function SvgRedCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.729,
    height: 12.728,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 12.729 12.728"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    fill: "#e81c5c",
    "data-name": "Rectangle 39",
    rx: 1,
    transform: "rotate(225 8.293 4.02)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    fill: "#e81c5c",
    "data-name": "Rectangle 132",
    rx: 1,
    transform: "rotate(-45 13.658 5.656)"
  })));
};
export default SvgRedCross;